export function downloadBlob(blob: Blob, filename: string): HTMLAnchorElement {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename.length > 0 ? filename : 'download';
  const clickHandler = (): void => {
    setTimeout(() => {
      URL.revokeObjectURL(url);
      link.removeEventListener('click', clickHandler);
    }, 150);
  };
  link.addEventListener('click', clickHandler, false);
  link.click();
  return link;
}

export function downloadFileFromURL(url: string): HTMLAnchorElement {
  const link = document.createElement('a');
  link.href = url;
  link.download = 'download';
  const clickHandler = (): void => {
    setTimeout(() => {
      URL.revokeObjectURL(url);
      link.removeEventListener('click', clickHandler);
    }, 150);
  };
  link.addEventListener('click', clickHandler, false);
  link.click();
  return link;
}

export function downloadCSV(csvContent: string, filename: string): HTMLAnchorElement {
  const link = document.createElement('a');
  link.href = 'data:text/csv;charset=utf-8,' + encodeURI(csvContent);
  link.target = '_blank';
  link.download = filename.length > 0 ? filename : 'download';
  link.click();
  return link;
}
